import { render, staticRenderFns } from "./OrganismSidebarUniverse.vue?vue&type=template&id=69c547aa&"
import script from "./OrganismSidebarUniverse.vue?vue&type=script&lang=js&"
export * from "./OrganismSidebarUniverse.vue?vue&type=script&lang=js&"
import style0 from "./OrganismSidebarUniverse.vue?vue&type=style&index=0&id=69c547aa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports